export default "__VITE_ASSET__9766be16__"